export const rootPath = '/user';
export const createPath = `${rootPath}/create`;
export const viewPath = `${rootPath}/view`;
export const createGroupPath = `${rootPath}/group/create`;
export const viewGroupPath = `${rootPath}/group/view`;
export const permissionPath = `${rootPath}/permission`;
export const commandPanelPath = `${rootPath}/commands`;

export function getUserPath(userId) {
  return `${viewPath}/${userId}`;
}

export function getUserGroupPath(userGroupId) {
  return `${viewGroupPath}?id=${userGroupId}`;
}

export const getUserTabGroupPath = (userId) => `${getUserPath(userId)}/user-groups`;
export const getUserRadPermissionsPath = (userId) => `${getUserPath(userId)}/rad-permissions`;
